const validateMaxLength = (maxLength, element) => {
    if (!(element.value)) {
        return true;
    } 

    return element.value.length <= maxLength;
}

export default validateMaxLength